import { FoodsToggleButton, FoodsToggleButtonType } from "@foodpilot/foods";
import { formatCompanyLabel, CompanySelectionProps } from "./CompanySelection";
import { CircularProgress, useTheme } from "@mui/material";

export const CompaniesButtons = (props: CompanySelectionProps) => {
    const { companies, selectedCompanyId, onChange, posts } = props;
    const theme = useTheme();

    if (posts === undefined) return <CircularProgress size={38} />;

    const selectedSupplier = companies.find((company) => company.id === selectedCompanyId);

    const supplierButtons: FoodsToggleButtonType[] = companies.map((company) => {
        const currentPost = posts.find((item) => item.organization?.id === company.id);
        const total = currentPost?.completions.ssq.result || 0;

        return {
            id: company.id,
            label: formatCompanyLabel(company, total),
            onClick: () => onChange(company),
            color: total === 100 ? theme.custom.green[600] : undefined,
        };
    });
    const initialSelectedButton = supplierButtons.find((i) => i.id === selectedSupplier?.id);

    return <FoodsToggleButton buttons={supplierButtons} initialSelected={initialSelectedButton} />;
};
